<!--
수기 미수 완료 모달 컴포넌트
------------------------------------
사용: app.$refs['manual-resolve'].form({ id, ... })
패턴: billing-retry.vue 참조
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical" style="width: 640px; max-width: 90vw">

            <div class="uk-modal-header">
                <h4 class="uk-text-center">수기 결제확인</h4>
            </div>

            <div class="uk-modal-body" style="overflow-y: auto; max-height: 70vh">

                <!-- 안내 -->
                <div style="padding: 12px 16px; margin-bottom: 16px; background: #f5f5f5; border: 1px solid #e0e0e0; border-radius: 4px; color: #666">
                    <i class="material-icons uk-text-middle" style="font-size: 18px">info</i>
                    <strong>수기완료 안내</strong>
                    <ul style="margin: 8px 0 0 0; padding-left: 20px; font-size: 13px; line-height: 1.8">
                        <li>이 과금건의 상태를 <strong>결제완료</strong>로 변경합니다.</li>
                        <li>실제 결제는 시스템에서 진행되지 않습니다. <strong>회원사와 별도 협의</strong>하여 진행해야 합니다.(계좌이체 등..)</li>
                        <li>세금계산서 발행 또한 시스템에서 자동 처리되지 않으므로 <strong>별도 처리</strong>가 필요합니다.</li>
                    </ul>
                </div>

                <!-- 과금 정보 -->
                <table class="uk-table uk-table-small uk-table-divider" style="font-size: 13px; margin: 0; table-layout: fixed; width: 100%">
                    <colgroup>
                        <col style="width: 100px">
                        <col>
                    </colgroup>
                    <tbody>
                    <tr>
                        <td class="uk-text-muted">과금번호</td>
                        <td>#{{ billing.id }}</td>
                    </tr>
                    <tr>
                        <td class="uk-text-muted">과금일</td>
                        <td>{{ billing.billing_date }}</td>
                    </tr>
                    <tr v-if="billing.user_nick">
                        <td class="uk-text-muted">회원사</td>
                        <td>{{ billing.user_nick }}</td>
                    </tr>
                    <tr>
                        <td class="uk-text-muted">과금타입</td>
                        <td>{{ billing.billing_type_text }}</td>
                    </tr>
                    <tr>
                        <td class="uk-text-muted">결제수단</td>
                        <td>{{ billing.payment_method_label }}</td>
                    </tr>
                    <tr>
                        <td class="uk-text-muted">결제금액</td>
                        <td style="font-weight: 700; color: #f0506e">{{ numberFormat(billing.total_amount) }}원</td>
                    </tr>
                    <tr v-if="billing.arrears_reason">
                        <td class="uk-text-muted">실패 사유</td>
                        <td class="uk-text-danger" style="word-break: break-all">{{ billing.arrears_reason }}</td>
                    </tr>
                    </tbody>
                </table>

                <!-- 처리 메모 -->
                <div style="margin-top: 16px">
                    <label style="font-size: 13px; font-weight: 600; display: block; margin-bottom: 4px">
                        처리 메모 <span style="color: #f0506e">*</span>
                    </label>
                    <textarea class="uk-textarea" v-model="memo" rows="3"
                              placeholder="수기 완료 처리 사유를 입력하세요 (예: 계좌이체 확인, 현금 수령 등)"
                              style="font-size: 13px"></textarea>
                </div>

                <!-- 에러 메시지 -->
                <div v-if="errorMsg" class="uk-alert uk-alert-danger" style="margin-top: 12px">
                    {{ errorMsg }}
                </div>
            </div>

            <div class="uk-modal-footer uk-text-right">
                <button type="button"
                        class="uk-button uk-button-default uk-modal-close">
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button type="button"
                        class="uk-button uk-button-danger"
                        :disabled="submitting || !memo.trim()"
                        @click="submit()">
                    <i class="material-icons uk-text-middle" style="font-size: 18px">check</i>
                    수기완료 확인
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            csrfToken: String,
        },
        data: function () {
            return {
                billing: {},
                memo: '',
                errorMsg: '',
                submitting: false,
            };
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm: function () {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼 — 외부에서 호출
             * @param {Object} billingData 과금 정보 객체
             */
            form: function (billingData) {
                this.billing = billingData;
                this.memo = '';
                this.errorMsg = '';
                this.submitting = false;
                this.displayForm();
            },

            /**
             * 수기완료 실행
             */
            submit: function () {
                if (!this.memo.trim()) {
                    this.errorMsg = '처리 메모를 입력해주세요.';
                    return;
                }

                this.errorMsg = '';
                this.submitting = true;

                var self = this;

                var load = new Promise(function (resolve, reject) {
                    $.app.ajax.module.default({
                        type: 'post',
                        url: '/admin/billing-arrears/' + self.billing.id + '/resolve',
                        data: {
                            '_token': self.csrfToken,
                            'memo': self.memo,
                        },
                        success: function (response) {
                            resolve(response);
                        },
                        error: function (jqXHR) {
                            reject(jqXHR);
                        },
                    });
                });

                load.then(function (response) {
                    UIkit.modal(self.$el).hide();

                    if (response.success) {
                        var msg = '미결제건 수기처리가 완료되었습니다.';
                        if (response.remaining_arrears_count !== undefined) {
                            if (response.remaining_arrears_count === 0) {
                                msg += '<br><br><span style="color:#32d296;font-weight:600">모든 미결제가 해결되어 출고제한이 해제됩니다.</span>';
                            } else {
                                msg += '<br><br>아직 <strong>' + response.remaining_arrears_count + '건</strong>의 미결제가 남아있습니다.';
                            }
                        }
                        UIkit.modal.alert(msg).then(function () {
                            $.app.refresh();
                        });
                    } else {
                        UIkit.modal.alert(response.msg || '수기완료 처리에 실패하였습니다.').then(function () {
                            $.app.refresh();
                        });
                    }
                }).catch(function (jqXHR) {
                    self.submitting = false;

                    if (jqXHR.responseJSON && jqXHR.responseJSON.msg) {
                        self.errorMsg = jqXHR.responseJSON.msg;
                    } else {
                        self.errorMsg = '수기완료 요청 중 오류가 발생했습니다.';
                    }
                });
            },

            /**
             * 숫자 포맷
             */
            numberFormat: function (num) {
                if (!num && num !== 0) return '0';
                return Number(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
        },
    };
</script>
